import {formActions} from "@/enums/formActions";

const initState = () => ({
  wishListItemCount: 0,
  wishListItems: []
})

export  const  state = initState

export const getters = {
  getWishListCount(state){
    return state.wishListItemCount;
  }
}

export const mutations = {
  setWishListItems(state, {wishListItems}) {
    state.wishListItems = wishListItems
  },
  setWishListItemCount(state){
    state.wishListItemCount = state.wishListItems.length;
  },
  setItemsCount(state, {wishListItemCount}) {
    state.wishListItemCount = wishListItemCount;
  }
}

export const actions = {
  async getWishListItems({commit}){
    try {
      const wishListItems = await this.$axios.$get('/wishlists/wishListItems');
      commit('setWishListItems', {wishListItems})
      commit('setWishListItemCount')

    }catch (error) {
      const message = error.response?.data?.Message
        || error.response?.data?.message
        || "Error while fetching wishlist items"
      this.$toast.error(message)
      console.error(error)
    }
  },
  getWishlistItemCount({commit}){
    this.$catch(
      async () => {
        const response = await this.$axios.$get('/wishlists/items-count');
        const wishListItemCount = response?.value;
        commit('setItemsCount', {wishListItemCount})
      },
      formActions.Load,
      'wishlist item count'
    )
  },
  async addToWishlist({commit, dispatch}, {shoppingCartItem, path}) {
    return new Promise((resolve, reject) => {
      this.$catch(
        async () => {
          const addToWishlistResult = await this.$axios.$post(
            '/wishlists/addtowishlist',
            shoppingCartItem
          )
          if (addToWishlistResult.hasErrors === false) {
            dispatch('getWishListItems')
            commit('setWishListItemCount')
          }
          resolve(addToWishlistResult)
        },
        formActions.Save,
        'addToWishList'
      )
    })
  },
  async addCartToWishlist({commit, dispatch}, {cartItems, wishListId}) {
    return new Promise((resolve, reject) => {
      this.$catch(
        async () => {
          const addToWishlistResult = await this.$axios.$post(
            `/wishlists/${wishListId}/add-cart`,
            cartItems
          )
          resolve(addToWishlistResult)
        },
        formActions.Save,
        'addCartToWishlist'
      )
    })
  },
  async deleteWishlistItem({commit, dispatch}, {wishListItemId}) {
    return new Promise((resolve, reject) => {
      this.$catch(
        async () => {
          const deleteWishlistItemResult = await this.$axios.$delete(
            `/wishlists/wishlist-item/${wishListItemId}`
          )
          if (deleteWishlistItemResult.hasErrors === false) {
            dispatch('getWishListItems')
            commit('setWishListItemCount')
          }
          resolve(deleteWishlistItemResult)
        },
        formActions.Delete,
        'deleteWishListItem'
      )
    })
  },
}
